import React, { useState, Component, Suspense } from 'react';
import styled from "styled-components";
import Axios from 'axios';
import { clearInterval } from 'timers';
import {wrapperEndPoint} from "../../../Utils/Api";
import QuickLinksJsonData from '../../../../QuickLinkData.json';
import isInsignia from '../../../Utils/IsInsignia';
import getImg from '../../../Utils/getImg.js';
import Imagedummy from '../../../../assets/imgs/welcomeScreen/ThemeRbl/image.png'



const QuickLinksBody = styled.div `

display:block;
`

const QuickLinksBlock = styled.div`
    

    display : -webkit-box;
    display : -ms-flexbox;
    display : flex;
    -webkit-box-orient : horizontal;
    -webkit-box-direction : normal;
    // -ms-flex-flow : row wrap;
    // flex-flow : row wrap;
    flex-wrap: wrap;

    padding: 2% 3%;
    padding-bottom: 0%;
    position: static;
    gap: 10px;

   

`

const QuickLinkActionElem = styled.div`

  border-radius: 5px;
  border: solid 1px #2c387a;
  padding: 10px;
  margin-right: 7px;
  font-size: 11.5px;
  color: #2c387a;
  display: inline-block;
  margin-bottom: 10px;
  text-align: center;
  cursor: pointer;
  transition: 0.1s all ease-in-out;

}

 &:hover{
  background: #2c387a;
  color: $bg-color;
}`

const FlexIcon = styled.div`
    display:-webkit-box;
    display:-ms-flexbox;
    display:flex;
    -webkit-box-pack:center;
    -ms-flex-pack:center;
        justify-content:center;
    -webkit-box-align: center;
    -ms-flex-align: center;
        align-items: center;

    width:65%;
    height:65%;

    margin-bottom: 4px;
    cursor:pointer;
    position: relative;

    // @media only screen and (min-width: 768px) and (max-width: 959px){
    //     & {
    //      width:60px;
    //      height:60px;
    //     }
    // }
    .quicklink-image-cover {
      animation: fadeColor 6s infinite !important;
      background-color: #070D44;
      padding: 8px !important;
      border-radius: 50% !important;
    }
    @keyframes fadeColor {
      0% {
          background-color: #070D44;
      }
      50% {
          background-color: #2F55FF;
      }
      100% {
          background-color: #070D44;
      }
    }

`

const CustomQuickLink = styled.div`
    display : -webkit-box;
    display : -ms-flexbox;
    display : flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
        -ms-flex-direction: column;
            flex-direction: column;
    -webkit-box-align:center;
        -ms-flex-align:center;
            align-items:center;
    width : 31.4%;

	// margin-right: ${80 / 6}px;

  //       margin-bottom: 3%;
    position: relative;
    box-sizing: border-box;
    border: 1.5px solid rgba(0, 113, 255, 0.2);
    border-radius: 10px;
    padding: 6px 4px 6px;
    background: rgba(0, 113, 255, 0.1);
    // background: #fff;
    box-shadow: 0 1px 4px rgba(0, 113, 255, 0.08);
    transition: 0.2s all ease-in-out;
    // gap: 10px;
    height: 110px;

    &:hover {
        border-color: rgba(0, 113, 255, 0.5);
        box-shadow: 0 3px 10px rgba(0, 113, 255, 0.18);
    }

    &.ql-highlighted {
        background: radial-gradient(circle at 100% 130%, #ae0105, #2e0202);
        border-color: #ae0105;
        // background: rgba(0, 113, 255, 0.1);
    }

    &.ql-highlighted div:last-child, &.ql-highlighted a:last-child {
        color: #ffffff !important;
        background: transparent !important;
    }

    //here
    .special-text{
       // color: #2c387a !important;
        font-weight: 600;
    }
    .rotate {
        -webkit-animation: anim 3.5s infinite linear;
           animation: anim 3.5s infinite linear;
       }
       
       @-webkit-keyframes anim {
        //  from {-webkit-transform: rotateY(0deg);}
        //  to {-webkit-transform: rotateY(360deg);}
            0% {transform: rotateY(0deg);}
            50% {transform: rotateY(90deg);}
            50.1% {transform: rotateY(270deg);}
            100% {transform: rotateY(360deg);}
       }
       
       @keyframes anim {
        // from {-webkit-transform: rotateY(0deg);}
        // to {-webkit-transform: rotateY(360deg);}
           0% {transform: rotateY(0deg);}
           50% {transform: rotateY(90deg);}
           50.1% {transform: rotateY(270deg);}
           100% {transform: rotateY(360deg);}
       }
       
       .new-quicklink {
        position: absolute;
        left: 78%;
        font-size: 11.5px;
        top: 0;
        color: red;
        padding: 6px;
        font-weight: 600;
        border-radius: 18px;
        
     
    }


	${FlexIcon}:hover{
		/* background : #00dc94; */

		& svg{
			fill : #fff;
			animation : none;
		}
	}

	&& div:last-child, && a:last-child{
		font-size : 12px;
		color: #555;
		border: 0 !important;
		border-radius : 0;
		background : transparent;
		margin : 0;
		padding:0;
	}

	&& > div:last-child:hover, && a:last-child:hover{
		background : transparent;
		color: #959191;
		animation : none;
	}
`


class QuickLinks extends Component {

 constructor(props) {
    super(props);
    this.state = {
      quickLinksData : []

    };
  }

  componentDidMount() {

    //console.log(this.state.quickLinksData)


    Axios.get(wrapperEndPoint.QuickLinkURL ,{ withCredentials: false})                         
    .then(response => {
      this.setState({quickLinksData:response.data})
     
      console.log(response)
      //console.log(this.state.quickLinksData)
    })
    .catch(error => {
      console.log(error)
    })




  }

   handleQuickLink = (quickLinkName, actionType, i) => {

  //  console.log(quickLinkName + " -->  " + actionType, i);

    if(actionType === "autoSubmit"){
      let inputString = this.state.quickLinksData[i].autoSubmit + "<split>" + this.state.quickLinksData[i].autoSubmit;
      window["autosubmit"](inputString);   
    }
    if(actionType === "redirectLink"){
      window.open(this.state.quickLinksData[i].redirectLink); 
    }
    if(actionType === "overlay"){
      document.getElementById("ql_"+quickLinkName).click();
    }
    if(actionType === "subCategory"){
      let subCategoryArray = this.state.quickLinksData[i].subCategory;
      this.props.handleJustUIPrintCall(quickLinkName)
  
     // console.log(subCategoryArray)

        let subResponse = 
        "<div>Please select one of the options to continue or type your query below.</div>"
        +
        `<div>${subCategoryArray.map((item,j)=>{
            if(item.actionText.indexOf("MULTICHOICELINK") > -1) {
                let url = item.actionText.split("MULTICHOICELINK")[1].trim();
                return '<a href="'+url+'" target="_blank" class="action-elem">'+item.displayText+'</a>';
            }
            if(item.actionText.indexOf("WFTRIGGER") > -1) {
                let triggerText = item.actionText.split("WFTRIGGER")[1].trim();
                return '<div class="action-elem" onClick="javascript:autosubmit(\''+triggerText+'\',\''+j+'\')">'+item.displayText+'</div>';
            }
            return(
                '<div class="action-elem" onClick="javascript:autosubmit(\''+item.actionText+'\',\''+j+'\')">'+item.displayText+'</div>'  
                )
        }).join('')}</div>` 
       
        setTimeout(() => {
          this.props.addServerResponse({ answer: subResponse});
          this.props.hideWelcomeScreen();
        }, 100);
  
    }

  }



  render() {


    return (
      <QuickLinksBlock>

      {
        this.state.quickLinksData.map((ql, i) => {
        return (  

          <CustomQuickLink key={i}
            className={ql.name === "Make Credit Card Payment" ? 'ql-highlighted' : ''}
            onClick={()=>{this.handleQuickLink(ql.name,ql.type,i)}}
          >
            <FlexIcon >
              {
                ql.id == "quicklink8" 
                ? (
                  <div className='quicklink-image-cover'>
                      <img style={{width:"34px",height:"30px"}} 
                        src={ql.image}
                        alt="" 
                      />
                  </div>
                )
                : ( 
                  <img style={{width:"40px",height:"40px"}} 
                    className={(ql.id=="quicklink5")?'rotate':''} 
                    src={isInsignia() ? ql.imageInsignia : ql.image}
                    alt="" 
                  /> 
                )
              }
            </FlexIcon>
            <QuickLinkActionElem
              className={'special-text'}
              //{(ql.id=="quicklink5" || ql.id=="quicklink8")?'special-text':''}  // || ql.id=="quicklink8" || ql.id=="quicklink7"
             
            >
              {ql.name}
            </QuickLinkActionElem>
          </CustomQuickLink>
        )
        })
      }

  
      </QuickLinksBlock> 
  
    )
  }
}





export default QuickLinks;











